module.exports = __webpack_public_path__ + "static/media/code.2e965aa4.jpg";